import { useRoutes } from 'react-router-dom';

// routes
// import AuthenticationRoutes from './AuthenticationRoutes';
import AdminRoute from './AdminRoute';
import AuthenticationRoutes from './AuthenticationRoutes';
import PageNotFound from 'PageNotFound';

// ==============================|| ROUTING RENDER ||============================== //

export default function ThemeRoutes() {
  return useRoutes([AuthenticationRoutes,AdminRoute,{path:'*',element:<PageNotFound/>}]);
}
